// extracted by mini-css-extract-plugin
export var btn = "style-module--btn--4cdc0";
export var btnDay = "style-module--btn-day--d7f9f";
export var btnEmpty = "style-module--btn-empty--4e5ab";
export var btnWrap = "style-module--btn-wrap--98991";
export var day = "style-module--day--0d267";
export var daysList = "style-module--days-list--1ed13";
export var form = "style-module--form--f94f2";
export var info = "style-module--info--24064";
export var infoLeft = "style-module--info-left--d0eae";
export var infoRight = "style-module--info-right--e8ef2";
export var num = "style-module--num--34c0b";
export var orgList = "style-module--org-list--3265f";
export var policy = "style-module--policy--3f6b0";
export var price = "style-module--price--f2f21";
export var reg = "style-module--reg--a345f";
export var tt = "style-module--tt--49f47";
export var wrap = "style-module--wrap--d7dcc";